<h1 mat-dialog-title>{{title}}</h1>

<div mat-dialog-content>
  <ng-container>
    <p *ngFor="let line of lines">{{line}}</p>
  </ng-container>
</div>

<div mat-dialog-actions [align]="'end'">
  <button mat-button (click)="onOkClick()" id="infoDialogOK">OK</button>
</div>
